import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { ProjectDetailMobileListItemComponent } from "@components/project-cards/project-detail-mobile-list-item/project-detail-mobile-list-item.component";
import { TranslateProjectImageTagPipe } from "@domain/project/translate-project-image-tag.pipe";
import { AutocompleteSearchFilterPipe } from "@odx/angular/components/autocomplete";

@Component({
  selector: "app-project-detail-mobile-image-card",
  templateUrl: "./project-detail-mobile-image-card.component.html",
  styleUrls: ["./project-detail-mobile-image-card.component.scss"],
  standalone: true,
  imports: [
    UiKitModule,
    ReactiveFormsModule,
    ProjectDetailMobileListItemComponent,
    TranslateProjectImageTagPipe,
    AutocompleteSearchFilterPipe,
  ],
})
export class ProjectDetailMobileImageCardComponent {
  private formBuilder = inject(FormBuilder);

  @Input({ required: true }) fileUrl!: string;
  @Input({ required: true }) fileName!: string;
  @Input() description?: string;
  @Input() tags?: string[];
  @Input() expanded = false;
  @Input() isReadOnlyUser = false;
  @Input() hasWritePermission = false;
  @Input() isMonitoringScope = false;
  @Input() tagList: string[] = [];

  @Output() delete$ = new EventEmitter<void>();
  @Output() submit$ = new EventEmitter<FormGroup>();
  @Output() preview$ = new EventEmitter<void>();
  @Output() toggleExpand$ = new EventEmitter<void>();

  editForm = this.formBuilder.group({
    name: new FormControl<string | null>(null, Validators.required),
    description: [""],
    tags: new FormControl<string[] | null>(null),
  });

  editEnabled = false;

  onToggleExpand() {
    if (!this.editEnabled) {
      this.toggleExpand$.emit();
    }
  }

  onOpenEdit() {
    if (!this.hasWritePermission) {
      return;
    }

    if (!this.expanded) {
      this.toggleExpand$.emit();
    }
    this.editForm.patchValue({ name: this.fileName, description: this.description, tags: this.tags });
    this.editEnabled = true;
  }

  onDelete() {
    if (this.hasWritePermission) {
      this.delete$.emit();
    }
  }

  onSubmit() {
    if (!this.editForm.valid) {
      return;
    }

    if (this.hasWritePermission) {
      this.submit$.emit(this.editForm);
      this.editEnabled = false;
    }
  }

  cancelEditMode() {
    this.editEnabled = false;
  }
}
